import { Component, Input } from '@angular/core';

@Component({
  selector: 'split-truncate-text',
  templateUrl: './split-truncate-text.component.html',
  styleUrls: ['./split-truncate-text.component.scss']
})
export class SplitTruncateTextComponent {
  @Input() public text!: string;
  @Input() public width: string = '136px';
}
